import Repository from "./Repository";

const LEADS = "leads";

export default {
    postLead(payload) {
        return Repository.post(`${LEADS}`, payload);
    },
};
